import React, { useEffect, useState } from 'react';
import CustomDatePicker from '../../common/datepicker';
import SaveModal from '../../modal/saveModal';

function GroupReservation({ onChangeSegments }) {
    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);
    const [selectDate, setSelectDate] = useState(null);
    const [fMinDate, setFMinDate] = useState(null);

    useEffect(() => {
        if (saveStatus === false) {
            const onKeyDown = (e) => {
                if (e.key === 'Enter') {
                    setSaveStatus(true);
                }
            };
            window.addEventListener('keydown', onKeyDown);
            return () => window.removeEventListener('keydown', onKeyDown);
        }
    }, [saveStatus]);

    // 초기 구간 정보 배열 (구간 1)
    const [segments, setSegments] = useState([
        { id: 1, routeFrom: '', routeTo: '', flightNo: '', date: '' },
    ]);

    useEffect(() => {
        const segmentLength = segments.length - 1;
        setSelectDate(segments[segmentLength].date);
        onChangeSegments(segments);
    }, [segments, onChangeSegments]);

    // 구간 추가 버튼 클릭 시 새로운 구간을 배열에 추가
    const handleAddSegment = (segId) => {
        const newSegments = [...segments]; // 원본 복사

        const newSeg = {
            id: segId + 1,
            routeFrom: '',
            routeTo: '',
            flightNo: '',
            date: selectDate ?? '',
        };

        // 1. 새 SEG 삽입 (index는 segId - 1 기준)
        newSegments.splice(segId, 0, newSeg);

        // 2. 뒤에 있는 SEG id 재정렬
        for (let i = segId + 1; i < newSegments.length; i++) {
            newSegments[i].id++;
        }
        setFMinDate(newSegments[0].date);
        setSegments(newSegments);
    };

    // 각 구간의 값 변경 처리 (필요에 따라 확장 가능)
    const handleChange = (id, field, value) => {
        setSegments(
            segments.map((segment) =>
                segment.id === id ? { ...segment, [field]: value } : segment,
            ),
        );
    };

    return (
        <>
            <SaveModal content={modalContent} SaveBtn={saveStatus} onClose={modalAction} />
            {segments.map((segment, index) => (
                <tr key={segment.id} data-id={segment.id}>
                    <th>
                        <span className='important-value'>*</span> 구간 {segment.id}
                    </th>
                    <td>
                        <div className='table-padding wpal-route-check-wrap'>
                        <div className='wpal-date-wrap group'>
                                <span className='wpal-date' style={{ width: '30%' }}>
                                    출발일자
                                </span>
                                <CustomDatePicker
                                    selectedDate={segment.date}
                                    onChange={(date) => handleChange(segment.id, 'date', date)}
                                    useTimeSelect={false}
                                    // minDate={segments.length === 1 ? selectDate : undefined}
                                    minDate={fMinDate}
                                    style={{ width: '52%' }}
                                />
                            </div>
                            <div className='wpal-flightCode-wrap'>
                                <span className='wpal-flightCode'>편명</span>
                                <input
                                    type='text'
                                    value={segment.flightNo}
                                    maxLength={6}
                                    style={{ width: '58%' }}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const pattern = /^[A-Za-z]?$|^[A-Za-z]{2}[0-9]*$/;

                                        if (
                                            /[ㄱ-ㅎㅏ-ㅣ가-힣]/.test(value) ||
                                            (value.length >= 2 && !pattern.test(value))
                                        ) {
                                            setModalContent(
                                                '편명을 입력 형식에 맞게 작성해주세요. \n(편명: 항공사 2CODE + 숫자)',
                                            );
                                            setModalAction(() => () => setSaveStatus(true));
                                            setSaveStatus(false);
                                            return;
                                        }

                                        handleChange(
                                            segment.id,
                                            'flightNo',
                                            value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase(),
                                        );
                                    }}
                                />
                            </div>
                            <div className='wpal-route-wrap'>
                                <span className='wpal-route'>노선</span>
                                <input
                                    type='text'
                                    value={segment.routeFrom}
                                    placeholder='3CODE'
                                    maxLength={3}
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        if (/[ㄱ-ㅎㅏ-ㅣ가-힣]|\d/.test(value)) {
                                            setModalContent(
                                                '노선을 입력 형식에 맞게 작성해주세요. \n(노선: 3CODE)',
                                            );
                                            setModalAction(() => () => setSaveStatus(true));
                                            setSaveStatus(false);
                                            return;
                                        }

                                        handleChange(
                                            segment.id,
                                            'routeFrom',
                                            value.replace(/[^a-zA-Z]/g, '').toUpperCase(),
                                        );
                                    }}
                                />
                                <span className='wpal-separator'>-</span>
                                <input
                                    type='text'
                                    value={segment.routeTo}
                                    placeholder='3CODE'
                                    maxLength={3}
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        if (/[ㄱ-ㅎㅏ-ㅣ가-힣]|\d/.test(value)) {
                                            setModalContent(
                                                '노선을 입력 형식에 맞게 작성해주세요. \n(노선: 3CODE)',
                                            );
                                            setModalAction(() => () => setSaveStatus(true));
                                            setSaveStatus(false);
                                            return;
                                        }

                                        handleChange(
                                            segment.id,
                                            'routeTo',
                                            value.replace(/[^a-zA-Z]/g, '').toUpperCase(),
                                        );
                                    }}
                                />
                            </div>
                            
                            {/* 마지막 구간에만 '구간 추가' 버튼 노출 */}
                            {/* {index === segments.length - 1 && ( */}
                            <div className='wpal-route-add-wrap group-reservation'>
                                <button
                                    className='wpal-routeAdd'
                                    onClick={() => handleAddSegment(segment.id)}
                                >
                                    + 추가
                                </button>
                                {segments.length > 1 ? (
                                    <button
                                        className='wpal-routeRemove'
                                        onClick={() => {
                                            const newSegments = segments
                                                .filter((seg) => seg.id !== segment.id) // 1. 해당 SEG 제거
                                                .map((seg, index) => ({
                                                    ...seg,
                                                    id: index + 1, // 2. id 재정렬
                                                }));

                                            setSegments(newSegments);
                                        }}
                                    >
                                        - 삭제
                                    </button>
                                ) : (
                                    <></>
                                )}
                            </div>
                            {/* )} */}
                        </div>
                    </td>
                </tr>
            ))}
        </>
    );
}

export default GroupReservation;
